import React, { Component } from 'react'
import { message } from 'antd'
import _ from 'lodash'
import $ from 'jquery'
import qs from 'query-string'
import { __ } from '@wordpress/i18n'

import './styles.module.scss'
import { API_HOST } from 'configs/env'
import AppHelper from 'libs/AppHelper'
import whttp from 'libs/whttp'

const INDEX_URL = _.get(window, 'VC_CONFIG.INDEX_URL')
const Locale = _.get(window, 'VC_CONFIG.Locale')
const defaultListInfo = {
  current: 1,
  page_size: 10,
  total: 1,
  rows: [],
}

export default class RecipeInfo extends Component {
  state = {
    recipeInfo: {
      category_name: '',
      condiments: [],
      dips: [],
      dishes: [],
      images: [],
      ingredients: [],
      name: '',
      source: '',
      steps: [],
    },
    listInfo: {
      current: 1,
      page_size: '10',
      rows: [],
      total: 40,
    },
  }

  componentDidMount() {
    this.loadData()
  }

  loadData = () => {
    const queryParams = qs.parse(window.location.search)
    const recipe = queryParams.recipe

    if (!recipe) return
    whttp.get(`${API_HOST}/api/v1/recipes/${recipe}`, null, (state, res) => {
      const { code = 100, reason = '發生錯誤', data = {} } = res

      if (state === false || code !== 200) {
        message.warning(reason)
        this.props.history.replace(`${INDEX_URL}/recipes`)
        return
      }

      this.setState({ recipeInfo: data }, () => {
        this.loadSimilarData(data)
      })
      this.loadHTMLdesc(data)
    })
    this.reloadSwiper()
  }

  loadSimilarData = (recipeInfo, opt = { page: 1, pageSize: 10 }) => {
    const queryString = qs.stringify(
      {
        page: opt.page,
        page_size: opt.pageSize,
        'category_ids[]': [recipeInfo.category_id],
      },
      { skipNull: true }
    )
    whttp.sharedGet(
      `${API_HOST}/api/v1/recipes?${queryString}`,
      null,
      (state, res) => {
        const { code = 100, reason = '發生錯誤', data = {} } = res

        if (state === false || code !== 200) {
          return
        }

        this.setState({ listInfo: data })
      }
    )
  }

  loadHTMLdesc = (info = {}) => {
    if (info.source.length > 7) {
      document.getElementById('output-source-content').innerHTML = info.source
    }
    if (info.additional.length > 7) {
      document.getElementById('output-additional-content').innerHTML =
        info.additional
    }
  }

  reloadSwiper = () => {
    const Swiper = window.Swiper
    var init = false
    $(document).ready(function() {
      var swiper1

      /* Which media query */
      function swiperMode() {
        let mobile = window.matchMedia(
          '(min-width: 0px) and (max-width: 767px)'
        )
        let tablet = window.matchMedia(
          '(min-width: 767px) and (max-width: 1024px)'
        )
        let desktop = window.matchMedia('(min-width: 1025px)')

        // Enable (for mobile)
        if (mobile.matches) {
          if (!init) {
            init = true
            swiper1 = new Swiper('.event-card-scroll_mobile', {
              spaceBetween: 10,
              loop: true,
              slidesPerView: 'auto',
              // init: false,
              pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
              },
              breakpoints: {
                767: {
                  spaceBetween: 0,
                },
              },
            })
          }
        }

        // Disable (for tablet)
        else if (tablet.matches) {
          if (swiper1) swiper1.destroy()
          init = false
        }

        // Disable (for desktop)
        else if (desktop.matches) {
          if (swiper1) swiper1.destroy()
          init = false
        }
      }

      /* On Load
       **************************************************************/
      window.addEventListener('load', function() {
        swiperMode()
      })

      /* On Resize
       **************************************************************/
      window.addEventListener('resize', function() {
        swiperMode()
      })
    })
  }

  render() {
    const { recipeInfo, listInfo } = this.state
    const Local = _.get(window, 'VC_CONFIG.Locale')

    return (
      <main class='bg-light'>
        <div class='container'>
          <div class='breadcrumb-wrap py-4 m-0'>
            <nav aria-label='breadcrumb'>
              <ol class='breadcrumb' style={{ justifyContent: 'left' }}>
                <li class='breadcrumb-item'>
                  <a
                    href={`${window.VC_CONFIG.INDEX_URL}${
                      Local == 'en_US' ? '/en' : ''
                    }`}>
                    {__('首頁', 'cec-plugin-stores')}
                  </a>
                </li>
                <li class='breadcrumb-item'>
                  <a
                    href={`${window.VC_CONFIG.INDEX_URL}/recipes${
                      Local == 'en_US' ? '-en' : ''
                    }`}>
                    {__('廚房', 'cec-plugin-stores')}
                  </a>
                </li>
                <li class='breadcrumb-item'>
                  <a
                    href={`${window.VC_CONFIG.INDEX_URL}/recipes${
                      Local == 'en_US' ? '-en' : ''
                    }`}>
                    {recipeInfo.category_name}
                  </a>
                </li>
                <li class='breadcrumb-item active' aria-current='page'>
                  {recipeInfo.name}
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div class='banner banner-md'>
          <div class='banner-image'>
            <img
              src={`${
                window.VC_CONFIG.PLUGIN_ASSETS_URL
              }img/banner/kitchen/banner-kitchen.png`}
              alt=''
            />
            <h3 class='title mb-0'>{__('廚房', 'cec-plugin-stores')}</h3>
          </div>
        </div>
        <div class='container'>
          <section class='pt-5'>
            <div class='row'>
              <div class='col-md-8 col-lg-9 mb-4'>
                <h4 class='heading-title align-items-center'>
                  {recipeInfo.name}
                  <div class='add-favorite' />
                </h4>
                <hr class='border-top border-gray mt-0 mb-4' />
                <div class='card shadow-0 border-0 bg-transparent mb-5'>
                  <div class='row'>
                    <div class='col-lg-4'>
                      <div
                        class='img-1-1 mb-lg-0 mb-3'
                        style={{
                          backgroundImage: `url('${_.get(
                            recipeInfo,
                            'images.0',
                          )}')`,
                        }}
                      />
                    </div>
                    <div class='col-lg-8'>
                      <div class='d-flex flex-column justify-content-between'>
                        <div class='row'>
                          <div class='col-6'>
                            <div class='d-flex align-items-center p-3'>
                              <i class='icon-people2 h3 text-font mb-0 line-hight-fit mr-4' />
                              <p class='h6 mb-0 text-font'>
                                {__('份量', 'cec-plugin-stores')}
                              </p>
                              <span class='d-inline-block ml-auto h6 text-primary mb-0'>
                                {_.get(recipeInfo, 'portion', 1)}
                                {__('人份', 'cec-plugin-stores')}
                              </span>
                            </div>
                            <hr class='border-top border-gray mt-0 mb-4' />
                          </div>
                          <div class='col-6'>
                            <div class='d-flex align-items-center p-3'>
                              <i class='icon-timer h3 text-font mb-0 line-hight-fit mr-4' />
                              <p class='h6 mb-0 text-font'>
                                {__('準備', 'cec-plugin-stores')}
                                <span class='d-none d-md-inline'>
                                  {__('時間', 'cec-plugin-stores')}
                                </span>
                              </p>
                              <span class='d-inline-block ml-auto h6 text-primary mb-0'>
                                {_.get(recipeInfo, 'prepare_time')}{' '}
                                {__('分鐘', 'cec-plugin-stores')}
                              </span>
                            </div>
                            <hr class='border-top border-gray mt-0 mb-4' />
                          </div>
                          <div class='col-6'>
                            <div class='d-flex align-items-center p-3'>
                              <i class='icon-star h3 text-font mb-0 line-hight-fit mr-4' />
                              <p class='h6 mb-0 text-font'>
                                {__('難度', 'cec-plugin-stores')}
                              </p>
                              <span class='d-inline-block ml-auto h6 text-primary mb-0'>
                                {_.get(recipeInfo, 'level_name')}
                              </span>
                            </div>
                            <hr class='border-top border-gray mt-0 mb-4' />
                          </div>
                          <div class='col-6'>
                            <div class='d-flex align-items-center p-3'>
                              <i class='icon-cook h3 text-font mb-0 line-hight-fit mr-4' />
                              <p class='h6 mb-0 text-font'>
                                {__('烹調', 'cec-plugin-stores')}
                                <span class='d-none d-md-inline'>
                                  {__('時間', 'cec-plugin-stores')}
                                </span>
                              </p>
                              <span class='d-inline-block ml-auto h6 text-primary mb-0'>
                                {_.get(recipeInfo, 'cook_time')}{' '}
                                {__('分鐘', 'cec-plugin-stores')}
                              </span>
                            </div>
                            <hr class='border-top border-gray mt-0 mb-4' />
                          </div>
                        </div>
                        <p
                          class='h6 mb-3 text-font fw-300'
                          dangerouslySetInnerHTML={{
                            __html: _.get(recipeInfo, 'desc'),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {[
                  {
                    list: recipeInfo.ingredients,
                    name: __('主要食材', 'cec-plugin-stores'),
                  },
                  {
                    list: recipeInfo.dishes,
                    name: __('配菜', 'cec-plugin-stores'),
                  },
                  {
                    list: recipeInfo.condiments,
                    name: __('調味料', 'cec-plugin-stores'),
                  },
                  {
                    list: recipeInfo.dips,
                    name: __('醃料', 'cec-plugin-stores'),
                  },
                ]
                  .filter((collection) => collection.list.length > 0)
                  .map(({ list, name }) => (
                    <section class='py-3'>
                      <h4 class='heading-title align-items-center'>
                        {name}
                      </h4>
                      <hr class='border-top border-gray mt-0 mb-4' />
                      <div class='row'>
                        {_.map(list, (item) => (
                          <div class='col-md-6'>
                            <div class='row no-gutters mx-n3 p-3'>
                              <div class='col px-3'>
                                {item.url == null && (
                                  <p
                                    class='h6 mb-0 text-font limit-line-lg-1'
                                    data-toggle='tooltip'
                                    data-placement='top'
                                    title={item.name}>
                                    {item.name}
                                  </p>
                                )}
                                {item.url != null && (
                                  <p
                                    class='h6 mb-0 text-font limit-line-lg-1'
                                    data-toggle='tooltip'
                                    data-placement='top'
                                    title={item.name}>
                                    <a
                                      href={item.url}
                                      style={{ color: '#6e6060' }}
                                      target='_blank'
                                      rel='noopener noreferrer'>
                                      {item.name}
                                      <span>
                                        <h class='icon icon_cart-full' />
                                      </span>
                                    </a>
                                  </p>
                                )}
                              </div>
                              <div class='col-auto px-3'>
                                <p class='h6 mb-0 text-primary'>
                                  {item.portion}
                                  {item.unit}
                                </p>
                              </div>
                            </div>
                            <hr class='border-top border-gray mt-0 mb-4' />
                          </div>
                        ))}
                      </div>
                    </section>
                  ))}
                {recipeInfo.youtube && (
                  <section class='py-3'>
                    <iframe
                      class='w-100 my-4'
                      height='350'
                      src={recipeInfo.youtube}
                      frameborder='0'
                      allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                      allowfullscreen=''
                      title='youtube'
                    />
                  </section>
                )}
                {recipeInfo.steps.length > 0 && (
                  <section class='py-3'>
                    <h4 class='heading-title align-items-center'>
                      {__('烹調步驟', 'cec-plugin-stores')}
                    </h4>
                    <hr class='border-top border-gray mt-0 mb-4' />
                    {_.map(recipeInfo.steps, (item, idx) => (
                      <div class='card shadow-0 border-0 mb-3'>
                        <div class='row no-gutters align-items-lg-center'>
                          <div class='col-4 col-md-3 col-lg-2'>
                            <div
                              class='img-1-1'
                              style={{
                                backgroundImage: `url('${_.get(
                                  item,
                                  'image.url',
                                )}')`,
                              }}
                            />
                          </div>
                          <div class='col'>
                            <div class='card-body px-md-5 p-3'>
                              <h6 class='h3 text-primary mb-3'>
                                Step {idx + 1}
                              </h6>
                              <p class='h6 text-font text-justify mb-0'>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.desc,
                                  }}
                                />
                                {item.tip && (
                                  <p
                                    className='note text-success mb-0'
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        __('訣竅', 'cec-plugin-stores') +
                                        ': ' +
                                        item.tip,
                                    }}
                                  />
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </section>
                )}
                {/* 了解更多 有值就顯示 */}
                {recipeInfo.source.length > 7 && (
                  <section class='py-3'>
                    <h4 class='heading-title align-items-center'>
                      {__('了解更多', 'cec-plugin-stores')}
                    </h4>
                    <hr class='border-top border-gray mt-0 mb-4' />
                    <div class='card shadow-0 border-0 bg-transparent mb-5'>
                      <div class='row'>
                        <div class='col-lg-8'>
                          <div class='d-flex flex-column justify-content-between'>
                            <p
                              id='output-source-content'
                              class='p mb-3 text-font fw-300'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}
              </div>
              <div class='col-md-4 col-lg-3 mb-4'>
                <h5 class='heading-subTitle align-items-start'>
                  {__('推薦食譜', 'cec-plugin-stores')}
                </h5>
                <hr class='border-top border-gray mt-0 mb-4' />
                <div class='event-card-scroll_mobile mb-md-0 mb-5 swiper-container'>
                  <div class='row no-gutters mx-n3 w-auto swiper-wrapper'>
                    {_.map(_.get(listInfo, 'rows', []), (item) => (
                      <div class='col-auto col-md-12 px-3 mb-4 swiper-slide'>
                        <a
                          class='card shadow-0 border-0'
                          role='button'
                          href={`${INDEX_URL}/recipe-info${
                            Locale == 'en_US' ? '-en' : ''
                          }/?recipe=${item.name}`}>
                          <div class='row no-gutters align-items-center'>
                            <div class='col-md-6'>
                              <div
                                class='img-1-1'
                                style={{
                                  backgroundImage: `url('${_.get(
                                    item,
                                    'images.0',
                                  )}')`,
                                }}
                              />
                            </div>
                            <div class='col-md-6'>
                              <div class='card-body px-4 py-3'>
                                <h5 class='note text-font limit-line-3 mb-0'>
                                  {item.name}
                                </h5>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    ))}
                  </div>
                  <div class='swiper-pagination' />
                </div>
                <div class='row' />
              </div>
            </div>
          </section>
        </div>
      </main>
    )
  }
}

// 編輯器
export class RecipeInfoEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }

  componentDidMount() {
    AppHelper.updateConfig()
  }

  fetchData = () => {
    const id = _.get(this, 'props.match.params.id')
    if (!id) return
    whttp.get(API_HOST + `/api/v1/recipes/${id}`, null, (state, res) => {
      const { code = 100, reason = '發生錯誤', data = {} } = res

      if (state === false || code !== 200) {
        message.warning(reason)
        this.props.history.replace('/recipes')
        return
      }
      this.fillData(data)
    })
  }

  render() {
    return (
      <div className='vu-blocks-editor'>
        <div class='components-placeholder__label'>
          <span class='block-editor-block-icon'>
            <div class='dashicons dashicons-book' />
          </span>
          食譜詳細資訊
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/recipes/recipe-info.js